<template>
    <div>
        <headerNav title="搜索关键词"/>
        <van-search
            v-model="keyword"
            show-action
            placeholder="请输入搜索关键词"
            @search="doSearch"
            >
            <template #action>
                <div @click="doSearch()">搜索</div>
            </template>
        </van-search>
        <div class="mh">
            <div class="mh-tit">
                <div>
                    历史搜索
                    <van-icon class="mh-tit-close" :size="14" @click="oldDelete" name="close"/>
                </div>
            </div>
            <div class="mh-list">
                <van-tag class="mh-list-tag" round type="primary" v-for="(item,index) in oldKeywordList" @click="doSearch(item)" :key="index">{{item}}</van-tag>
            </div>
        </div>
       
    </div>
</template>
<script>
export default {
    data(){
        return{
            keyword:'',
            oldKeywordList:[],
            limitlength:30,//限制保存多少个记录
        }
    },
    created(){
        this.init();
    },
    methods:{
        init(){
            this.loadOldKeyword();
        }, 
        //加载历史记录
        loadOldKeyword() {
            var res= localStorage.getItem("OldKeys");
            var OldKeys = JSON.parse(res);
            this.oldKeywordList = OldKeys;
            console.log("打印数据",this.oldKeywordList);
        },
        //清除历史搜索
        oldDelete() {
            this.$dialog.confirm({title:'提示',message:'确定清除历史搜索记录？'}).then(()=>{
                console.log('用户点击确定');
                localStorage.removeItem("OldKeys");
                this.oldKeywordList=[];
            })
        },
        doSearch(keyword) {
			
            keyword = !keyword?this.keyword:keyword;

            this.keyword = keyword;
            if(keyword)
            {
                this.saveKeyword(keyword); //保存为历史 
            }
            
            this.$router.push({path:'/productlist',query:{name:keyword}});
            
            //跳转到对应页面进行查询
            
        },
        saveKeyword(keyword) {
           var str=localStorage.getItem("OldKeys")||'';
           var curjson=[];
           if(str)
           {
               curjson=JSON.parse(str);
           }
           if(curjson.filter(x=>x==keyword).length<1)
           {
               if(curjson.length>=this.limitlength)
               {
                    curjson.splice(0,1); //去除第一个
               }

               curjson.push(keyword); //加入第一个
               localStorage.setItem("OldKeys", JSON.stringify(curjson));
               this.oldKeywordList=curjson;
           }
		}
    }

}
</script>
<style lang="scss" scoped>
    .mh{
        margin:10px;
        border-radius: 10px 10px 0 0px;
        background-color: #fff;
        padding: 10px;
        font-size: 14px;
        height: 300px;
    }
    .mh-tit{
        position: relative;
        margin-bottom: 10px;
    }
    .mh-tit-close{
        position: absolute;
        right: 10px;

    }
    
    .mh-list-tag{
        font-size: 14px;
        margin-right: 15px;
        padding: 2px 12px;
        margin-bottom: 8px;
    }
</style>